import {
  ADVANCE_UPLOAD_REQUEST,
  ADVANCE_UPLOAD_SUCCESS,
  ADVANCE_UPLOAD_FAIL,
  ADVANCE_UPLOAD_RESET,
  ADVANCE_LIST_REQUEST,
  ADVANCE_LIST_SUCCESS,
  ADVANCE_LIST_FAIL,
  ADVANCE_UPDATE_REQUEST,
  ADVANCE_UPDATE_SUCCESS,
  ADVANCE_UPDATE_FAIL,
  ADVANCE_UPDATE_RESET,
  ADVANCE_DELETE_REQUEST,
  ADVANCE_DELETE_SUCCESS,
  ADVANCE_DELETE_FAIL,
  ADVANCE_DELETE_RESET,
  ATTENDANCE_UPLOAD_REQUEST,
  ATTENDANCE_UPLOAD_SUCCESS,
  ATTENDANCE_UPLOAD_FAIL,
  ATTENDANCE_UPLOAD_RESET,
  ATTENDANCE_LIST_REQUEST,
  ATTENDANCE_LIST_SUCCESS,
  ATTENDANCE_LIST_FAIL,
  ATTENDANCE_UPDATE_REQUEST,
  ATTENDANCE_UPDATE_SUCCESS,
  ATTENDANCE_UPDATE_FAIL,
  ATTENDANCE_UPDATE_RESET,
  ATTENDANCE_DELETE_REQUEST,
  ATTENDANCE_DELETE_SUCCESS,
  ATTENDANCE_DELETE_FAIL,
  ATTENDANCE_DELETE_RESET,
  ATTENDANCE_STATS_REQUEST,
  ATTENDANCE_STATS_SUCCESS,
  ATTENDANCE_STATS_FAIL,
  BONUS_UPLOAD_REQUEST,
  BONUS_UPLOAD_SUCCESS,
  BONUS_UPLOAD_FAIL,
  BONUS_UPLOAD_RESET,
  BONUS_LIST_REQUEST,
  BONUS_LIST_SUCCESS,
  BONUS_LIST_FAIL,
  BONUS_UPDATE_REQUEST,
  BONUS_UPDATE_SUCCESS,
  BONUS_UPDATE_FAIL,
  BONUS_UPDATE_RESET,
  BONUS_DELETE_REQUEST,
  BONUS_DELETE_SUCCESS,
  BONUS_DELETE_FAIL,
  BONUS_DELETE_RESET,
} from '../constants/masterConstants';

// ========== ADVANCE REDUCERS ==========

export const advanceUploadReducer = (state = {}, action) => {
  switch (action.type) {
    case ADVANCE_UPLOAD_REQUEST:
      return { loading: true };
    case ADVANCE_UPLOAD_SUCCESS:
      return { loading: false, success: true, uploadResult: action.payload };
    case ADVANCE_UPLOAD_FAIL:
      return { loading: false, error: action.payload };
    case ADVANCE_UPLOAD_RESET:
      return {};
    default:
      return state;
  }
};

export const advanceListReducer = (state = { records: [] }, action) => {
  switch (action.type) {
    case ADVANCE_LIST_REQUEST:
      return { loading: true, records: [] };
    case ADVANCE_LIST_SUCCESS:
      return {
        loading: false,
        records: action.payload.records,
        currentPage: action.payload.currentPage,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
      };
    case ADVANCE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const advanceUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case ADVANCE_UPDATE_REQUEST:
      return { loading: true };
    case ADVANCE_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case ADVANCE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case ADVANCE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const advanceDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case ADVANCE_DELETE_REQUEST:
      return { loading: true };
    case ADVANCE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case ADVANCE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case ADVANCE_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// ========== ATTENDANCE REDUCERS ==========

export const attendanceUploadReducer = (state = {}, action) => {
  switch (action.type) {
    case ATTENDANCE_UPLOAD_REQUEST:
      return { loading: true };
    case ATTENDANCE_UPLOAD_SUCCESS:
      return { loading: false, success: true, uploadResult: action.payload };
    case ATTENDANCE_UPLOAD_FAIL:
      return { loading: false, error: action.payload };
    case ATTENDANCE_UPLOAD_RESET:
      return {};
    default:
      return state;
  }
};

export const attendanceListReducer = (state = { records: [] }, action) => {
  switch (action.type) {
    case ATTENDANCE_LIST_REQUEST:
      return { loading: true, records: [] };
    case ATTENDANCE_LIST_SUCCESS:
      return {
        loading: false,
        records: action.payload.records,
        currentPage: action.payload.currentPage,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
      };
    case ATTENDANCE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const attendanceUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case ATTENDANCE_UPDATE_REQUEST:
      return { loading: true };
    case ATTENDANCE_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case ATTENDANCE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case ATTENDANCE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const attendanceDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case ATTENDANCE_DELETE_REQUEST:
      return { loading: true };
    case ATTENDANCE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case ATTENDANCE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case ATTENDANCE_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const attendanceStatsReducer = (state = { stats: {} }, action) => {
  switch (action.type) {
    case ATTENDANCE_STATS_REQUEST:
      return { loading: true, stats: {} };
    case ATTENDANCE_STATS_SUCCESS:
      return { loading: false, stats: action.payload };
    case ATTENDANCE_STATS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// ========== BONUS REDUCERS ==========

export const bonusUploadReducer = (state = {}, action) => {
  switch (action.type) {
    case BONUS_UPLOAD_REQUEST:
      return { loading: true };
    case BONUS_UPLOAD_SUCCESS:
      return { loading: false, success: true, uploadResult: action.payload };
    case BONUS_UPLOAD_FAIL:
      return { loading: false, error: action.payload };
    case BONUS_UPLOAD_RESET:
      return {};
    default:
      return state;
  }
};

export const bonusListReducer = (state = { records: [] }, action) => {
  switch (action.type) {
    case BONUS_LIST_REQUEST:
      return { loading: true, records: [] };
    case BONUS_LIST_SUCCESS:
      return {
        loading: false,
        records: action.payload.records || action.payload,
        currentPage: action.payload.currentPage,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords || (action.payload.records ? action.payload.records.length : action.payload.length),
      };
    case BONUS_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const bonusUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case BONUS_UPDATE_REQUEST:
      return { loading: true };
    case BONUS_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case BONUS_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case BONUS_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const bonusDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case BONUS_DELETE_REQUEST:
      return { loading: true };
    case BONUS_DELETE_SUCCESS:
      return { loading: false, success: true };
    case BONUS_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case BONUS_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
